import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	description: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	title: {
		defaultMessage: 'Failed to update',
		id: 'bulk-operations-common.submit-status.flags.error-flag.title',
		description: 'Bulk edit form submission error title',
	},
	description: {
		defaultMessage:
			'We were unable to make those changes. Try again, or view the items that failed to update.',
		id: 'bulk-operations-common.submit-status.flags.error-flag.description',
		description: 'Bulk edit form submission error flag description',
	},
});
export default messages;
